import styled from 'styled-components';

const TitleTable: React.FC = ({ children }) => {
  return <Container>{children}</Container>;
};

export default TitleTable;

const Container = styled.div`
  color: #3c6ab4;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.5px;
`;
